import * as React from "react";
import Input from "../Input-new/Input";
import Dropdown from "../Dropdown/Dropdown";
import Textarea from "../Textarea-new/Textarea";
import { calculateYearsAndMonths } from "../../utils";

const TeamMemberInfo = ({
  data,
  handleChangeInput,
  handleChangeDropdown,
  viewMode,
  deleted,
  addNewItem,
  isExists,
  handleParentDropdownChange,
  typeDuplicate
}) => {
  return (
    <div className="Team-member-info">
      <div className="Team-member-info_column">
      {(isExists) && <p className="errorText"> {typeDuplicate ? typeDuplicate : "Given Team Member Details Already Exists"}</p>}   
        <Dropdown
            className="Team-member-info_column_item"
            data={data}
            optionKey='code'
            optionLabelKey='name'
            optionsType="roles"
            value={data.is_agent}
            valueKey="is_agent"
            label="Role"
            handleParentChange={handleChangeDropdown}
            viewMode={viewMode}
            deleted={deleted}
        />              
        
         
        <Input className="Team-member-info_column_item"
            required
            valueType='text'
            name='first_name'
            label='First Name'
            value={data.first_name}                
            handleParentChange={handleChangeInput}
            viewMode={viewMode}
            deleted={deleted}
        />
        <Input className="Team-member-info_column_item"
            required
            valueType='text'
            name='last_name'
            label='Last Name'
            value={data.last_name}               
            handleParentChange={handleChangeInput}
            viewMode={viewMode}
            deleted={deleted}
        />
        <Input
            className="Team-member-info_column_item"
            placeholder="MM/DD/YYYY"
            type="text"
            valueType="date"
            name="starting_date"
            label="Start Date"
            value={data.starting_date}            
            handleParentChange={handleChangeInput}
            viewMode={viewMode}
            deleted={deleted}
        />

        <Input
            className="Team-member-info_column_item"
            disabled
            valueType="text"
            name="yrs_at_strive"
            label="Years at Strive"
            value={data.starting_date ? calculateYearsAndMonths(new Date(data.starting_date)):''}
            handleParentChange={handleChangeInput}
            viewMode={viewMode}
            deleted={deleted}
        />        
        <Input
            className="Team-member-info_column_item"
            placeholder="MM/DD/YYYY"
            type="text"
            valueType="date"
            name="birth_date"
            label="Birth Date"
            value={data.birth_date}            
            handleParentChange={handleChangeInput}
            viewMode={viewMode}
            deleted={deleted}
        />
        <Input
            className="Team-member-info_column_item"
            disabled
            valueType="text"
            name="age"
            label="Age"
            value={data.age}
            handleParentChange={handleChangeInput}
            viewMode={viewMode}
            deleted={deleted}
        />
        {/* {data.contact_type && (data.contact_type.includes("Lender") || data.contact_type.includes("Tenant")) ?
          <Input
            className="Team-member-info_column_item"
            name="name"
            label="Name"
            value={data.name}
            handleParentChange={handleChangeInput}
            viewMode={viewMode}
            deleted={deleted}
          />
          : ""
        } */}
        </div>
        <div className="Team-member-info_column"> 
        {data.is_agent !='n' && data.is_agent !='e' && data.is_agent !='i' && <div> 
        <Input
            className="Team-member-info_column_item"
            disabled
            placeholder="MM/DD/YYYY"
            type="text"
            valueType="date"
            name="on_phones"
            label="On Phones"
            value={data.on_phones}            
            handleParentChange={handleChangeInput}
            viewMode={viewMode}
            deleted={deleted}
        />        
        {/* <Input
            className="Team-member-info_column_item"
            disabled
            placeholder="MM/DD/YYYY"
            type="text"
            valueType="date"
            name="in_pool"
            label="In Pool"
            value={data.in_pool}            
            handleParentChange={handleChangeInput}
            viewMode={viewMode}
            deleted={deleted}
        />    */}
        </div>}
        {data.is_agent!='n' && data.is_agent !='e' && data.is_agent !='i' && <div>
        <Input
            className="Team-member-info_column_item"
            disabled
            placeholder="MM/DD/YYYY"
            type="text"
            valueType="date"
            name="first_listing"
            label="1st Listing"
            value={data.first_listing}            
            handleParentChange={handleChangeInput}
            viewMode={viewMode}
            deleted={deleted}
        />           
        <Input
            className="Team-member-info_column_item"
            disabled
            placeholder="MM/DD/YYYY"
            type="text"
            valueType="date"
            name="first_closing"
            label="1st Closing"
            value={data.first_closing}            
            handleParentChange={handleChangeInput}
            viewMode={viewMode}
            deleted={deleted}
        />     
        </div>}
        <Input
            className="Team-member-info_column_item"
            placeholder="MM/DD/YYYY"
            type="text"
            valueType="date"
            name="termination_date"
            label="Terminate Date"
            value={data.termination_date}            
            handleParentChange={handleChangeInput}
            viewMode={viewMode}
            deleted={deleted}
        />
        </div>
        <div className="Team-member-info_column">
        <Input
          required
          className="Team-member-info_column_item"
          valueType="email"
          name="email"
          label="Email"
          value={data.email}
          handleParentChange={handleChangeInput}
          viewMode={viewMode}
          deleted={deleted}
        />
        <Input
            className="Team-member-info_column_item"
            valueType="phone"
            name="phone"
            label="Work Phone"
            value={data.phone}
            handleParentChange={handleChangeInput}
            viewMode={viewMode}
            deleted={deleted}
        />    
        <Input
            required
            className="Team-member-info_column_item"
            valueType="phone"
            name="cell_phone"
            label="Cell Phone"
            value={data.cell_phone}
            handleParentChange={handleChangeInput}
            viewMode={viewMode}
            deleted={deleted}
        /> 
        <Input
            className="Team-member-info_column_item"
            valueType="text"
            name="address"
            label="Address"
            value={data.address}
            handleParentChange={handleChangeInput}
            viewMode={viewMode}
            deleted={deleted}
        />
        <Input
            className="Team-member-info_column_item"
            valueType="text"
            name="city"
            label="City"
            value={data.city}
            handleParentChange={handleChangeInput}
            viewMode={viewMode}
            deleted={deleted}
        />
       
        <Dropdown
            className="Team-member-info_column_item"
            data={data}
            optionsType="states"
            optionKey="abbr"
            optionLabelKey="name"
            value={data.state}
            valueKey="state"
            label="State"            
            handleParentChange={handleChangeDropdown}
            viewMode={viewMode}
            deleted={deleted}
        />
        <Input
            className="Team-member-info_column_item"
            valueType="number"
            maxLength={5}
            name="zip"
            label="Zip"
            value={data.zip}
            handleParentChange={handleChangeInput}
            viewMode={viewMode}
            deleted={deleted}
        />
          <Dropdown
          className="Team-member-info_column_item"
          dropdownType='multiple'
          optionsType='contactType'
          value={Array.isArray(data.contact_type) ? data.contact_type.join(",") : data.contact_type || ""}
          valueKey='contact_type'
          label='Contact Type'
          data={data}
          viewMode={viewMode}
          handleParentChange={handleParentDropdownChange}
        />
        {/* {data.contact_type && (data.contact_type.includes("Lender")) ? */}
        {data.contact_type && (Array.isArray(data.contact_type) ? data.contact_type.some((type) => type.split(",").includes("Lender")  )  : data.contact_type.split(",").includes("Lender")) ?
          <Input
            className="Team-member_column_item"
            name="name"
            required
            label="Company"
            value={data.name}
            handleParentChange={handleChangeInput}
            viewMode={viewMode}
            deleted={deleted}
          />
          : ""
        }
        {/* {data.contact_type && (data.contact_type.includes("Lender")) ? */}
        {/* {data.contact_type && (Array.isArray(data.contact_type) ? data.contact_type.some((type) => type.split(",").includes("Lender")  )  : data.contact_type.split(",").includes("Lender")) ?
          <Textarea
            className="Team-member_column_item"
            required
            valueType="text"
            inputType="textarea"
            //name="notes"
            name="notes"
            label="Notes"
            //value={data.NOTES}
            value={data.notes}
            viewMode={viewMode}
            handleParentChange={handleChangeInput}
            deleted={deleted}
            maxWidth="100%"
          /> : ""
        } */}
      </div>
    </div>
  );
};

export default TeamMemberInfo;
